import { render, staticRenderFns } from "./MediaVendor.vue?vue&type=template&id=6bf9168f&scoped=true"
import script from "./MediaVendor.vue?vue&type=script&lang=js"
export * from "./MediaVendor.vue?vue&type=script&lang=js"
import style0 from "./MediaVendor.vue?vue&type=style&index=0&id=6bf9168f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9168f",
  null
  
)

export default component.exports